import { GameTitle } from "./GameTitle";
import { Confetti } from "../Confetti";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class SplashState extends Phaser.State {

    public static currentInstance: SplashState;

    private playButton: Phaser.Button;
    private statsButton: Phaser.Button;
    private fadeInLayer: Phaser.Sprite;
    private gameTitle: GameTitle;
    private confetti: Confetti;

    public create(): void {

        SplashState.currentInstance = this;

        this.stage.disableVisibilityChange = true;

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "splash-background");
        background.anchor.set(.5);
        background.scale.y = GameVars.scaleY;

        this.confetti = new Confetti(this.game);
        this.add.existing(this.confetti.backgroundConfettiContainer);
        this.add.existing(this.confetti.foregroundConfettiContainer);

        // el pato y el messi
        this.add.image(500, 350, "texture_atlas_2", "splash_pato");

        const messi = this.add.image(15, 686, "texture_atlas_2", "splash_messi");
        messi.scale.y = GameVars.scaleY;

        this.gameTitle = new GameTitle(this.game);
        this.add.existing(this.gameTitle);

        // el boton de play
        this.playButton = this.add.button(670, 910, "texture_atlas_5", this.onClickPlay, this);
        this.playButton.setFrames("play_button_on", "play_button_off", "play_button_on");
        this.playButton.scale.set(0);
        this.playButton.anchor.set(.5);

        this.statsButton = this.add.button(690, 35 * GameVars.scaleY, "texture_atlas_5", this.onClickStats, this);
        this.statsButton.setFrames("stats_on", "stats_off", "stats_on");
        this.statsButton.anchor.set(.5);
        this.statsButton.scale.setTo(0);

        this.fadeInLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("intro_background"));
        this.fadeInLayer.scale.set(48, 16);

        this.add.tween(this.fadeInLayer).to({ alpha: 0 }, 1100, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.fadeInLayer.destroy();
            }, this);

        this.game.time.events.add(500, this.showTitle, this);

        this.game.time.events.add(1750, function (): void {
            this.confetti.activate();
        }, this);
    }

    public shutdown(): void {

        SplashState.currentInstance = null;

        this.confetti = null;

        super.shutdown();
    }

    public update(): void {

        this.confetti.update();
    }

    public showButtons(): void {

        this.game.add.tween(this.playButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out, true, 100)
            .onComplete.add(this.startPlayButtonAnimation, this);

        this.game.add.tween(this.statsButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 900);
    }

    public goToScene(nextScene: string): void {

        this.fadeInLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("black_square"));
        this.fadeInLayer.scale.set(12, 16);
        this.fadeInLayer.alpha = 0;

        this.add.tween(this.fadeInLayer)
            .to({ alpha: 1 }, 700, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.game.state.start(nextScene, true, false);
            }, this);
    }

    private startPlayButtonAnimation(): void {

        const pulseTween = this.game.add.tween(this.playButton.scale);
        pulseTween.to({ x: 1.05, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();

        if (!GameVars.gameReadyCalled) {
            GameVars.gameReadyCalled = true;
            ytgame.game.gameReady();
        }
    }

    private showTitle(): void {

        this.gameTitle.startAnimation();
    }

    private onClickPlay(): void {

        GameManager.newGame();

        AudioManager.getInstance().playEffect("play");
    }

    private onClickStats(): void {

        AudioManager.getInstance().playEffect("play");
        this.goToScene("StatsState");
    }
}
